import ReactDOM from "react-dom"
import { useState, useRef, useEffect } from "react";
import moment from 'moment';
//import { basePage } from "../consts/baseUrl";
import UpdateDriver from "./updatedriver"
import { suffix } from "../../utils/withdrawalOptions";
import { useNavigate, useParams } from "react-router-dom";
import { formatDOB, validateDate } from "../../components/consts/dateMask"
import { canadianProvinces } from "../../utils/countryOptions";
import { mexicanStates} from "../../utils/countryOptions";
import { countryOptions, usStates } from "../../utils/countryOptions";
import { stagingState } from "../../utils/withdrawalOptions";
import { defaultDriverData } from "../../utils/data";



export default function EditDriver({driverData}){
    const screenRef = useRef(null);
    const stateRef = useRef(null);
    const [formData, setFormData] = useState(driverData);
    const [err, setErr] = useState();
    const [ oth, setOth ] = useState("");
    const [ isOth, setIsOth ] = useState("");
    const [ dateErr, setDateErr ] = useState([]);
    const [state, setState] = useState(driverData.state);
    const [country, setCountry] = useState();
    const [stateStyle, setStateStyle] = useState(null);

    let stateLabel = ""
    if(country === "CA"){
        stateLabel = "Provence"
        
    } else {
        stateLabel = "State"
    }

    
    const [ stPrv, setStPrv ] = useState(stateLabel);

    const defined = (v) => v !== undefined && v !== null && v !== "";

    const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
            return;
        }
        setFormData((formData) => ({ ...formData, [name]: 0 }));
    }

    useEffect(() => {
        const setCountryOptions = (e) => {
        const value = e;
        setCountry(value);
        switch (value){
            case 'CA':
                setStateStyle(canadianProvinces);
            break;
            case 'MX':
                setStateStyle(mexicanStates);
            break;
            case 'US':
                setStateStyle(stagingState);
            break;
            default:
                setStateStyle(null);
            break
        }
    }
    setCountryOptions(driverData.cntTag); 
    },[driverData.cntTag])
    

    const handleCountryOptions = (e) => {
        const {value} = e.target;
        setCountry(value);
        setState("")
            switch (value){
                case 'CA':
                    setStateStyle(canadianProvinces);
                break;
                case 'MX':
                    setStateStyle(mexicanStates);
                break;
                case 'US':
                    setStateStyle(stagingState);
                break;
                default:
                    setStateStyle(null);
                break
        }
    }
    

    const handleChange = (e) => {

        //alert(country)

    //alert(e.targe.value)
        e.preventDefault();

        if(e.target.value === "oth"){
            setOth(true);
            setIsOth(true);
        } 
        if(country === "CA"){
            setStPrv("Province")
        } else {
            setStPrv("State")
        }

        if(e.target.value === "MEXICO"){
            setIsOth(false);
            setOth(false);
        }

        if(e.target.value === "UST"){
            setIsOth(false);
            setOth(false);
        }

        if(e.target.value === "US"){
            setIsOth(false);
            setOth(false);
        }

        const { name, value } = e.target;
        setFormData((formData) => ({ ...formData, [name]: value }));
    };

    const handleCancel = () => {
        let direct = "/driverdetails/"
        + driverData.driverState+"/"+ encodeURIComponent(driverData.driverLicense);
        window.location.replace(direct);
    }

/*
    const Cn = () => {
        return(
            <div>
                <select className="form-control form-select"
                    value={formData.state}
                    name="state"
                    onChange={(e) => handleChange(e)}>
                        <option>--Select--</option>
                        {canadianProvinces.map((opt) => (
                        <option key={opt.code} value={opt.code} title={opt.label}>
                            {opt.label}
                        </option>
                        ))}
                    </select>
            </div>
        )
    }

    const Mx = () => {
        return(
            <div>
                <select className="form-control form-select"
                    value={formData.state}
                    name="state"
                    onChange={(e) => handleChange(e)}>
                        <option>--Select--</option>
                        {mexicanStates.map((opt) => (
                        <option key={opt.label} value={opt.label} title={opt.label}>
                           {opt.label}
                        </option>
                        ))}
                    </select>
            </div>
        )
    }


    const Us = () => {
         return(
            <div>
                <select className="form-control form-select"
                    value={formData.state}
                    name="state"
                    onChange={(e) => handleChange(e)}>
                        <option>--Select--</option>
                        {usStates.map((opt) => (
                        <option key={opt.key} value={opt.key} title={opt.label}>
                            {opt.label}
                        </option>
                        ))}
                    </select>
            </div>
        )
    }

    const Ust = () => {
         return(
            <div>
                <select className="form-control form-select"
                    value={formData.state}
                    name="state"
                    onChange={(e) => handleChange(e)}>
                        <option>--Select--</option>
                        {countryOptions.US.map((opt) => (
                        <option key={opt.key} value={opt.key} title={opt.label}>
                            {opt.key} - {opt.label}
                        </option>
                        ))}
                    </select>
            </div>
        )
    }

    const Oth  = () => {

        return(
            <td scope="col">
                <input type="text"
                    name="state"
                    default=""
                    size="20"
                    onChange={(e) => handleChange(e)}
                    value={formData.state}>
                </input>
                </td>
        )
    }

    
    useEffect(() => {
    if(formData.country === "CANADA"){
        try {    
            ReactDOM.render(<Cn />,
                stateRef.current); 
            } catch(err){
                alert(err)
            }
        }    
    },[formData.country, formData.state])

    useEffect(() => {

        if(formData.country === "MEXICO"){
            try {    
                ReactDOM.render(<Mx />,
                    stateRef.current); 
            } catch(err){
                alert(err)
            }
        }
    },[formData.country, formData.state])

    useEffect(() => {
            if(formData.country === "US"){
            try {    
                ReactDOM.render(<Us />,
                    stateRef.current); 
                } catch(err){
                    alert(err)
                }
            }
    },[formData.country, formData.state])

    useEffect(() => {
        if(formData.country === "UST"){
            try {    
                ReactDOM.render(<Ust />,
                    stateRef.current); 
                } catch(err){
                    alert(err)
                }
            }

    
    },[formData.country, formData.state])

        useEffect(() => {
        if(formData.country === "oth"){
            try {    
                ReactDOM.render(<Oth formData={{formData}} handleChange={handleChange} />,
                    stateRef.current); 
                } catch(err){
                    alert(err)
                }
            }
    },[formData.country, formData.state])
*/
    const handleSave = (e, formData) => {

        let errs = [];
        /*
        if(country === ""){
            errs.push("No Country selected")
        }
            */

        //const date = validateDate(formData.dob, true, errs)
        //console.log(date)

        if(!defined(formData.dob)){
            errs.push("Date of Birth not valid")
        }

        if(formData.surName === ""){
            errs.push("Last Name Required ")
        }

        if(country === ""){
            errs.push("Country Required ")
        }

        if(errs.length > 0){
            setErr(errs)
            return;
        }
        
        // Validation minimal required fields
        if(formData.className === null){

        }


        e.preventDefault();

        const geo = {C: country, S: state}

        try {    
            ReactDOM.render(<UpdateDriver driverData={formData} geo={geo} />,
                screenRef.current); 
        } catch(err){
            alert(err)
        }
    }

    return(
        <div ref={screenRef}>
            <div>
             <div style={{color: "red"}}>{err}</div>
                <button type="button" className="btn btn-primary" 
                id="button" form='Index-form' style={{"textAlign": "start"}} 
                onClick={(e) => handleSave(e, formData)}
                >Save Driver Info.</button>

                <button type="button" className="btn btn-primary" 
                id="button" form='Index-form' style={{"textAlign": "start"}} 
                onClick={handleCancel}
                >Cancel</button>

                <div id="table" style={{fontSize: 'medium'}}>
                <h3>Driver General Information</h3>
                <table className="table table-striped table-bordered">
        
                <thead style={{width: '100%'}}>
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Middle Name</th>
                        <th scope="col"><span className="text-danger">*</span>Last Name</th>
                        <th scope="col">Suffix</th>
                        <th scope="col"><span className="text-danger">*</span>Date of Birth</th>
                    </tr>
                </thead>
                <tbody>
            <tr>
                <td scope="col">
                <input type="text"
                    name="firstName"
                    size="20"
                    onChange={(e) => handleChange(e)}
                    value={formData.firstName}>
                </input>
                </td>
                <td scope="col">
                <input type="text"
                    name="middleName"
                    default=""
                    size="20"
                    onChange={(e) => handleChange(e)}
                    value={formData.middleName}>
                </input>
                </td>
                <td scope="col">
                <input type="text"
                    name="surName"
                    size="20"
                    onChange={(e) => handleChange(e)}
                    value={formData.surName}>
                </input>
                </td>
                <td scope="col">
                    <select className="form-select"
                        value={formData.suffix}
                        name="suffix"
                        onChange={(e) => handleChange(e)}
                    >
                        <option defaultValue=""> -- Suffix -- </option>
                            {suffix.map((val) => (
                                <option value={val}>{val}</option>
                            ))}
                        </select>
                </td>
                <td scope="col">
                <input type="date" className="form-control" 
                    placeholder="MM/DD/YYYY"
                    data-index="1"  name='dob'  
                    onChange={(e) => handleChange(e)}
                    value={formData.dob}
                    max={moment().format("YYYY-MM-DD")}
                    onKeyDown={(e) => disableKey(e)}
                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                required />

                </td>
            </tr>
        </tbody>
        </table>
        <h3>Residence</h3>
        <table className="table table-striped table-bordered">
        
        <thead style={{width: '100%'}}>
            <tr>
            <th>Street Address1</th>
            <th>Street Address2</th>
            <th>City</th>
            <th>County</th>
            <th>{stPrv}</th>
            <th>Zip code</th>
            <th scope="col"><span className="text-danger">*</span>Country</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="col">
            <input type="text"
                    name="street1"
                    size="20"
                    onChange={(e) => handleChange(e)}
                    value={formData.street1}>
            </input>
            </td>
            <td scope="col">
            <input type="text"
                    name="street2"
                    size="20"
                    onChange={(e) => handleChange(e)}
                    value={formData.street2}>
            </input>
            </td>
            <td scope="col">
            <input type="text"
                    name="city"
                    size="20"
                    onChange={(e) => handleChange(e)}
                    value={formData.city}>
            </input>
            </td>
            <td scope="col">
            <input type="text"
                    name="county"
                    size="10"
                    onChange={(e) => handleChange(e)}
                    value={formData.county}>
            </input>
            </td>
            <td scope="col">
                    <div>
                
                                  {stateStyle === null ?
                                  (<input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setState(e.target.value)}
                                  value={state} />)
                                  :
                                  <select className="form-control form-select" aria-label=".form-select-lg example"
                                    value={state}
                                    onChange={(e) => setState(e.target.value)}>
                                        <option value= "" disabled> -- select an option -- </option>
                                        {stateStyle.map((opt) => (
                                            <option key={opt.code} value={opt.code}>
                                            {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                }
                                
                              </div>
            </td>
            <td scope="col">
            <input type="text"
                    name="zip"
                    size="8"
                    onChange={(e) => handleChange(e)}
                    value={formData.zip}>
            </input>
            </td>
            <td scope="col">        

                <select className="form-select" aria-label=".form-select-lg example"   
                                    value={country}
                                    onChange={handleCountryOptions}
                                >
                                    <option value=""> -- Country -- </option>
                                    <option value="US">(US) US - United States</option>
                                    {Object.values(countryOptions).flat().map((opt) => (
                                        <option key={opt.code} value={opt.code}>
                                        {opt.label}
                                        </option>
                    ))}
                </select>
                    
              
            {oth && (
                <div>
                  <select className="form-control form-select"
                    name="country"
                    value={country}
                    onChange={(e) => handleChange(e)}
                    >
                    <option>--Select Country--</option>
                    {countryOptions.OTH.map((opt) => (
                        <option key={opt.label} value={opt.label} title={opt.label}>
                           {opt.label}
                        </option>
                    ))}
                  </select>
                </div>
            )} 
            </td>
          </tr>
        </tbody>
        </table>
        </div>

            </div>
        </div>

    )
}
